import type { Project } from "@/interfaces/project";
import ProjectComponent from "./Project";

export default function ProjectList({
  projects,
  canCreate = true,
}: {
  projects: Project[];
  canCreate?: boolean;
}) {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {projects.map((project) => (
        <ProjectComponent key={project.id} project={project} />
      ))}

      {canCreate && (
        <a
          href="/projects/new"
          className="group border-line/40 bg-surface-alt hover:border-line hover:bg-surface flex min-h-52 flex-col items-center justify-center gap-1 border-2 border-dashed p-6 transition-colors"
        >
          <span className="font-display text-display text-ink-soft group-hover:text-ink leading-none font-bold transition-colors">
            +
          </span>
          <span className="font-display text-subheading text-ink-soft group-hover:text-ink font-bold transition-colors">
            Create new project
          </span>
        </a>
      )}
    </div>
  );
}
